export default "__VITE_ASSET__WSB1nzzo__"